import React from 'react';
import './SolutionsOverview.css';
import { FaCloud, FaShieldAlt, FaCogs, FaCheckCircle } from 'react-icons/fa';
import dashboard from "../images/dashboard2.png";

function SolutionsOverview() {
    const models = [
        { icon: <FaCloud />, title: "Cloud (SaaS)", desc: "Fully managed, pay-as-you-go platform with automatic updates and scaling." },
        { icon: <FaShieldAlt />, title: "Private Cloud", desc: "Dedicated environment with enhanced security and custom configurations." },
        { icon: <FaCogs />, title: "Custom Enterprise", desc: "On-premise or hybrid models for large institutions with specific needs." }
    ];

    const features = [
        "Real-time financial snapshot with fund management",
        "Role-specific views (MD, Manager, Recovery, Auditor)",
        "Mobile-responsive design with Excel/PDF export",
        "Gold personal & business loans in one interface"
    ];

    return (
        <section className="solutions-section-premium">
            <div className="solutions-container-premium">
                <div className="deployment-models-premium">
                    <div className="section-header-premium">
                        <h2 className="section-title-premium">Flexible Deployment</h2>
                        <p className="section-subtitle-premium">Choose the model that fits your institutional scale and security requirements.</p>
                    </div>
                    <div className="models-grid-premium">
                        {models.map((item, idx) => (
                            <div key={idx} className="model-card-premium">
                                <div className="model-icon-premium">{item.icon}</div>
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="dashboard-overview-premium">
                    <div className="overview-container-premium">
                        <div className="overview-image-premium">
                            {/* <div className="dashboard-mockup-premium">
                                <div className="mockup-header-premium">
                                    <div className="mockup-dots-premium">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <div className="mockup-bar-premium"></div>
                                </div>
                                <div className="mockup-body-premium">
                                    <div className="mockup-sidebar-premium">
                                        {[1, 2, 3, 4].map(i => <div key={i} className="sidebar-item-premium"></div>)}
                                    </div>
                                    <div className="mockup-content-premium">
                                        <div className="mockup-grid-premium">
                                            <div className="mockup-large-box-premium"></div>
                                            <div className="mockup-box-premium"></div>
                                            <div className="mockup-box-premium"></div>
                                            <div className="mockup-box-premium"></div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="overview-image-premium">
    <img
        src={dashboard}
        alt="Dashboard Preview"
        className="dashboard-image-premium"
    />
</div>
                        </div>
                        <div className="overview-text-premium">
                            <h2 className="section-title-premium">Unified Dashboard Experience</h2>
                            <p className="overview-intro-premium">A powerful, role-based dashboard providing a single view of all financial operations for management, branch heads, recovery teams, and auditors.</p>
                            <ul className="feature-list-premium">
                                {features.map((f, i) => (
                                    <li key={i}><FaCheckCircle className="check-icon-premium" /> {f}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <section className="core-banking-section">
  <div className="container">

    <h2 className="core-heading">
      Core Banking Capabilities
    </h2>

    <div className="core-grid">

      <div className="core-card">
        <div className="core-icon">👤</div>
        <h3>Know your Customer</h3>
        <p>In one click know and verify your </p>
      </div>

      <div className="core-card">
        <div className="core-icon">🏦</div>
        <h3>Core Banking Operations</h3>
        <p>Complete transaction processing across all banking activities.</p>
      </div>

      <div className="core-card">
        <div className="core-icon">💳</div>
        <h3>Loan Management System</h3>
        <p>End-to-end loan lifecycle management from approval to closure.</p>
      </div>

      <div className="core-card">
        <div className="core-icon">📈</div>
        <h3>Investment Module</h3>
        <p>SB, FD, RD and Debenture investment management system.</p>
      </div>

      <div className="core-card">
        <div className="core-icon">📊</div>
        <h3>Accounting & Audit</h3>
        <p>Automated ledger posting with secure audit trail tracking.</p>
      </div>

      <div className="core-card">
        <div className="core-icon">✅</div>
        <h3>Compliance & Reporting</h3>
        <p>Regulatory compliance monitoring with intelligent reporting.</p>
      </div>

    </div>

  </div>
</section>
        </section>
        
    );
}

export default SolutionsOverview;
